import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { getMaintenanceStatusUrl } from './../../../constants/url-constants';

@Injectable({
  providedIn: 'root'
})
export class MaintenanceService {

  constructor(private http: HttpClient) { }

  getMaintenanceStatus(): Observable<any> {
    return this.http.get(getMaintenanceStatusUrl);
  }
}
